import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import { UserOrder } from '@shared/generated'
import { formatPrice } from '@shared/uttils'

import styles from './styles.module.scss'

export default function OrderSummary ({ data }: { data: UserOrder }) {
  const { t: to } = useTranslation('order')
  const { t: tc } = useTranslation('common')

  return (
    <div className={styles.summary}>
      <h5>{to('order.total-order')}:</h5>
      {data?.meta?.length ? (
        <SummaryRow
          label={to('order.total-position')}
          value={`${data?.meta?.length} ${tc('weight.pc')}`}
        />
      ) : null}
      {data?.totalDiscount ? (
        <SummaryRow
          className={styles.summary__bonus}
          label={to('order.total-sum')}
          value={formatPrice(
            ((data.customerFinalCost as number) +
              data?.totalDiscount) as number,
          )}
        />
      ) : null}
      <SummaryRow
        label={to('order.total')}
        value={formatPrice(data?.customerFinalCost || 0)}
        isTotal
      />
      {data?.totalDiscount ? (
        <SummaryRow
          label={to('order.discount')}
          value={formatPrice(data?.totalDiscount)}
        />
      ) : null}
      {data?.totalCashback ? (
        <SummaryRow
          isBonus
          label={to('order.total-bonus')}
          value={formatPrice(data?.totalCashback)}
        />
      ) : null}
    </div>
  )
}

function SummaryRow ({
  label,
  value,
  isTotal = false,
  isBonus,
  className,
}: {
  label: string;
  value: string;
  isTotal?: boolean;
  isBonus?: boolean;
  className?: string;
}) {
  return (
    <p className={className}>
      {label}:
      <span data-total={isTotal ? true : undefined}>
        {isBonus && <ReactSVG src="/icons/bonus.svg" />}
        {value}
      </span>
    </p>
  )
}
